export default "__VITE_ASSET__97o3508T__"